import React from 'react';

export const EventDates = ({ displayEventSettings, event, lang }) => {
  return (
    <p className="dates">
      {displayEventSettings['ShowEventStartDateTime'] ? new Date(event.startDateTime).toLocaleDateString('sv-SE'): null}
      {displayEventSettings['ShowEventStartTime']
        ? (displayEventSettings['ShowEventStartDateTime'] ? ' ' : '') + new Date(event.startDateTime).toLocaleTimeString('sv-SE')
        : null}
      {(displayEventSettings['ShowEventStartDateTime'] || displayEventSettings['ShowEventStartTime']) &&
      (displayEventSettings['ShowEventEndDateTime'] || displayEventSettings['ShowEventEndTime'])
        ? ' - '
        : null}
      {displayEventSettings['ShowEventEndDateTime'] ? new Date(event.endDateTime).toLocaleDateString('sv-SE') : null}
      {displayEventSettings['ShowEventEndTime']
        ? (displayEventSettings['ShowEventEndDateTime'] ? ' ' : '') +
          new Date(event.endDateTime).toLocaleTimeString('sv-SE')
        : null}
    </p>
  );
};
